import { render, staticRenderFns } from "./redConfirmOrder.vue?vue&type=template&id=63a65583&scoped=true&lang=pug&"
import script from "./redConfirmOrder.vue?vue&type=script&lang=js&"
export * from "./redConfirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./redConfirmOrder.vue?vue&type=style&index=0&id=63a65583&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a65583",
  null
  
)

export default component.exports